module.exports = {
  signConfig: {
    appId: '20210918093911',
    secretKey: 'c57de344c9d5056de34d3b2d69f44a0d',
  },
}
